

        import React from 'react';
        import { Spinner } from '@fluentui/react-components';
        import styles from "./Shadow.module.css";

        const Shadows: React.FC = () => {
          return (
            <div className={styles.spinnerOverlay}>
            <div className={styles.spinnerContainer}>
    
            </div>
          </div>
          );
        };
        
        export default Shadows;
        